import angular from 'angular';
import dashboardComponent from './dashboard.component';
import PayZoneDashboardService from './dashboard.service';
import dashboardConfig from './dashboard.config';

let dashboardModule = angular.module('app.payZone.dashboard',[])
  .component('payZoneDashboard', dashboardComponent)
  .service('PayZoneDashboardService', PayZoneDashboardService)
  .config(dashboardConfig);

export default dashboardModule;



/** WEBPACK FOOTER **
 ** ./www/components/pay-zone/dashboard/dashboard.js
 **/